'use strict';
import * as $j_app$002epages$002e$002dDocument$002dTemplates$002dUpdate$002dPage$0024$002dCreate$002dForm$002dSend$002dAction$0024$0024anon$00241 from "./app.pages.-Document-Templates-Update-Page$-Create-Form-Send-Action$$anon$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction(templateId, templateNameValidatedRx, userSignal) {
  this.BM = null;
  this.Yf = null;
  this.M8 = null;
  this.BM = templateId;
  this.Yf = templateNameValidatedRx;
  this.M8 = userSignal;
}
export { $c_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction as $c_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction };
$p = $c_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction() {
}
export { $h_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction as $h_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction };
$h_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction)) {
    var x = this.BM;
    var x$2 = x$0.BM;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Yf;
      var x$4 = x$0.Yf;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.M8;
      var x$6 = x$0.M8;
      return (x$5 === x$6);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "CreateFormSendAction";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.BM;
      break;
    }
    case 1: {
      return this.Yf;
      break;
    }
    case 2: {
      return this.M8;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "templateId";
      break;
    }
    case 1: {
      return "templateNameValidatedRx";
      break;
    }
    case 2: {
      return "userSignal";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Vt = (function(validatedData, unvalidatedData) {
  return new $j_app$002epages$002e$002dDocument$002dTemplates$002dUpdate$002dPage$0024$002dCreate$002dForm$002dSend$002dAction$0024$0024anon$00241.$c_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction$$anon$1(unvalidatedData, this);
});
function $isArrayOf_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kk)));
}
export { $isArrayOf_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction as $isArrayOf_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction };
var $d_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction, "app.pages.DocumentTemplatesUpdatePage$CreateFormSendAction", ({
  kk: 1,
  fU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction as $d_Lapp_pages_DocumentTemplatesUpdatePage$CreateFormSendAction };
//# sourceMappingURL=app.pages.-Document-Templates-Update-Page$-Create-Form-Send-Action.js.map
